import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from "@angular/core";
import { DialogService } from "@app/services/dialog.service";
import { Store } from "@ngxs/store";

@Component({
    selector: 'app-image',
    templateUrl: './image.component.html',
    styleUrls: ['./image.component.scss']
})
export class ImageComponent implements OnInit {
    @Input() data?: any;
    isFullscreen = false;
    @ViewChild('imageContainer')
    imageContainer!: ElementRef<HTMLElement>;

    constructor(
        private readonly store: Store,
        private readonly dialog: DialogService
    ) { }

    ngOnInit(): void { }

    async downloadImage(): Promise<void> {
        try {
            const link = document.createElement('a');

            link.href = this.data.presignedUrl;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } catch (error) {
            console.error('Download failed:', error);
        }
    }

    enterFullscreen(): void {
        const element = this.imageContainer.nativeElement;

        if (element.requestFullscreen) {
            element.requestFullscreen();
        }
    }

    exitFullscreen(): void {
        if (document.fullscreenElement) {
            document.exitFullscreen();
        }
    }

    @HostListener('document:fullscreenchange')
    onFullscreenChange(): void {
        this.isFullscreen = !!document.fullscreenElement;
    }
}